import { isValidElement } from "react";
import { toast } from "sonner";
import { textoDoDetalhe } from "./erroApi";

// Rede de segurança: muitos ecrãs fazem toast.error(e.response.data.detail). Quando o servidor devolve um erro de
// validação, `detail` é uma lista de objetos e o React rebenta a página. Aqui qualquer mensagem que não seja texto nem
// elemento React passa a texto antes de chegar ao aviso.
const seguro = (fn) => (mensagem, opcoes) => {
  const texto = typeof mensagem === "string" || isValidElement(mensagem) || typeof mensagem === "function"
    ? mensagem
    : textoDoDetalhe(mensagem) || "Ocorreu um erro.";
  return fn(texto, opcoes);
};

["error", "warning", "info", "success", "message"].forEach((tipo) => {
  if (typeof toast[tipo] === "function") toast[tipo] = seguro(toast[tipo]);
});
